export const MALT_LOGO_URL = 'https://dam.malt.com/rebranding2020/malt-logo/malt-brew-only';

const MALT_FONTS = `
@font-face {
    font-family: 'Agrandir Tight';
    src: url('https://cdn.malt.com/npm/@maltjoy/themes/fonts/agrandir/agrandir-tightmedium-webfont.woff2') format('woff2');
    font-weight: 500;
    font-style: normal;
}
@font-face {
    font-family: 'Moderat';
    src: url('https://cdn.malt.com/npm/@maltjoy/themes/fonts/moderat/moderat-regular-webfont.woff2') format('woff2');
    font-weight: 400;
    font-style: normal;
}
@font-face {
    font-family: 'Moderat';
    src: url('https://cdn.malt.com/npm/@maltjoy/themes/fonts/moderat/moderat-bold-webfont.woff2') format('woff2');
    font-weight: 700;
    font-style: normal;
}
`;

export const LEGAL_AGREEMENT_PDF_STYLESHEET = `
${MALT_FONTS}
@page {
    margin: 18mm;

    @bottom-left {
        content: '';
        width: var(--joy-core-spacing-3);
        background: url('${MALT_LOGO_URL}') left center / var(--joy-core-spacing-3) no-repeat;
    }

    @bottom-right {
        content: counter(page) ' / ' counter(pages);
        font-family: var(--joy-font-family-base);
        font-size: var(--joy-font-size-primary-100);
        color: var(--joy-color-text-support);
    }
}

body {
    margin: 0;
}

.legal-agreement-pdf-content {
    font-family: 'Moderat', Arial, Helvetica, sans-serif;
    font-size: 11px;
    font-weight: 400;
    letter-spacing: -0.2px;
    line-height: 1.25;
    color: #1a1a1a;
}

.legal-agreement-pdf-content h1,
.legal-agreement-pdf-content h2 {
    font-family: 'Agrandir Tight', Arial, Helvetica, sans-serif;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 1.05;
    margin: 1.5em 0 0.5em;
}

.legal-agreement-pdf-content h3,
.legal-agreement-pdf-content h4,
.legal-agreement-pdf-content h5,
.legal-agreement-pdf-content h6 {
    font-family: 'Moderat', Arial, Helvetica, sans-serif;
    font-weight: 700;
    letter-spacing: -0.2px;
    line-height: 1.25;
    margin: 1.25em 0 0.5em;
}

.legal-agreement-pdf-content h1 {
    font-size: 36px;
}

.legal-agreement-pdf-content h2 {
    font-size: 28px;
}

.legal-agreement-pdf-content h3 {
    font-size: 20px;
    color: #fc5757;
}

.legal-agreement-pdf-content h4 {
    font-size: 16px;
}

.legal-agreement-pdf-content h5 {
    font-size: 14px;
}

.legal-agreement-pdf-content h6 {
    font-size: 11px;
}

.legal-agreement-pdf-content h1,
.legal-agreement-pdf-content h2,
.legal-agreement-pdf-content h3,
.legal-agreement-pdf-content h4,
.legal-agreement-pdf-content h5,
.legal-agreement-pdf-content h6 {
    break-after: avoid;
}

.legal-agreement-pdf-content p {
    margin: 0 0 0.75em;
}

.legal-agreement-pdf-content ul,
.legal-agreement-pdf-content ol {
    margin: 0 0 0.75em;
    padding-inline-start: 1.75em;
}

.legal-agreement-pdf-content li > p {
    margin: 0;
}

.legal-agreement-pdf-content blockquote {
    margin: 0 0 0.75em;
    padding: 0.25em 0 0.25em 1em;
    border-inline-start: 3px solid #d9d9d9;
    color: #4b4b4b;
}

.legal-agreement-pdf-content a {
    color: #0f6378;
    text-decoration: underline;
}

.legal-agreement-pdf-content s {
    text-decoration: line-through;
}

.legal-agreement-pdf-content mark {
    background-color: #eb73de;
    color: #ffffff;
    padding: 0 0.1em;
}

.legal-agreement-pdf-content .legal-agreement-variable {
    background-color: #ecf3f4;
    color: #035266;
    padding: 0 0.15em;
    border-radius: 2px;
    white-space: nowrap;
}

.legal-agreement-pdf-content hr {
    border: 0;
    border-top: 1px solid #d9d9d9;
    margin: 1.5em 0;
}

.legal-agreement-pdf-content .page-break {
    break-after: page;
    height: 0;
    margin: 0;
    border: 0;
}

.legal-agreement-pdf-content span {
    overflow-wrap: normal;
    word-break: normal;
}
`;
